/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var YesNoEnum;

(function (YesNoEnum) {
  YesNoEnum["YES"] = "yes";
  YesNoEnum["NO"] = "no";
})(YesNoEnum || (YesNoEnum = {}));